"use client";
import { useEffect } from "react";
import { inject, track } from "../generic";
import type { AnalyticsProps } from "../types";

/**
 * Injects the Analytics script into the page head and starts tracking page views.
 * @param [props] - Analytics options.
 * @param [props.mode] - The mode to use for the analytics script. Defaults to `auto`.
 *  - `auto` - Automatically detect the environment.  Uses `production` if the environment cannot be determined.
 *  - `production` - Always use the production script. (Sends events to the server)
 *  - `development` - Always use the development script. (Logs events to the console)
 */
function Analytics(
  props: AnalyticsProps & {
    framework?: string;
    route?: string | null;
    path?: string | null;
  }
): null {
  const config: AnalyticsProps & {
    framework: string;
  } = {
    framework: props.framework || "react",
    mode: props.mode,
    projectId: props.projectId,
  };

  useEffect(() => {
    inject(config);
  }, []);

  return null;
}

export { track, Analytics };
export type { AnalyticsProps };
